import { render, staticRenderFns } from "./lazyblock_openingtime.vue?vue&type=template&id=1672282c&scoped=true"
import script from "./lazyblock_openingtime.vue?vue&type=script&lang=js"
export * from "./lazyblock_openingtime.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_openingtime.vue?vue&type=style&index=0&id=1672282c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1672282c",
  null
  
)

export default component.exports